/*
 * Copyright (c) 2022 CalAmp Corp.  All Rights Reserved
 */
import {getVersion} from '@ion/core/src/environment/version';
import {useExternalTheme} from '@ion/dls/src/theme/useExternalTheme';
import {DLSTheme} from '@ion/dls/src/types/types';

/**
 * Provides the statically defined list of iOn Suite internal (non-white labelling)
 * domains.
 */
export const excludedDomains: readonly string[] = [
  'ion.calamp.com',
  'ion.calamp.co.uk',
  'stg.ion.calamp.com',
  'qa.ion.calamp.com',
  'dev.ion.calamp.com'
];

/**
 * Provides an encapsulation of the iOn Suite Application Theme and domain specific
 * constraints. If the current domain is included in the list of excluded domains,
 * the implementation default DLS theme will be used, otherwise, the externally
 * defined theme.json document will be retrieved from localStorage, or via HTTPS
 * are used.
 *
 * @param   url URL from which the theme is to be retrieved, defaults to `/theme.json`
 * @returns The application theme based on the default DLS theme, or the externally
 *          defined theme.
 */
export const useApplicationTheme = (): DLSTheme => {
  const theme: DLSTheme = useExternalTheme({
    version  : getVersion(),
    useCache : false,
    excludedDomains
  });
  return theme;
};

export default useApplicationTheme;
